import React, {Component} from 'react';
import {Container, Row, Col, CardGroup,Nav, CardImg, CardHeader, NavbarBrand,  Card, CardBody, Button, Input, InputGroup, InputGroupAddon,FormFeedback,FormGroup} from 'reactstrap';
import auth from '../../../auth/'


class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
  }

  SendLogin() {
    auth.login(this.state.username, this.state.password, (response) => {
        if (response.success) {
            this.props.history.push('/');
        }else{
          this.errors.className = 'col-12 invalid-feedback px-0' + ' d-block';
          this.errors.innerHTML = response.errors["global"];
        }
    })
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="p-4">
                  <div className="plapiqui-logo">
                  </div>
                  <CardBody>
                    <div  ref={(input) => { this.errors = input; }} className="col-12 invalid-feedback px-0"></div>
                    <InputGroup className="my-3 form-row">
                      <InputGroupAddon className="col-1"><i className="icon-user m-auto"></i></InputGroupAddon>
                      <Input className="col-11" onKeyDown={(e) => (e.keyCode==13 && this.state.password != ''?this.SendLogin():false)} onChange={ (e) => this.setState({ username: e.target.value }) } name="username" type="text" placeholder="Username"/>
                      <FormFeedback className="col-12"></FormFeedback>
                    </InputGroup>
                    <InputGroup className="mb-4 form-row">
                      <InputGroupAddon className="col-1"><i className="icon-lock m-auto"></i></InputGroupAddon>
                      <Input className="col-11" onKeyDown={(e) => (e.keyCode==13 && this.state.username != ''?this.SendLogin():false)} onChange={ (e) => this.setState({ password: e.target.value }) } name="password" type="password" placeholder="Password"/>
                      <FormFeedback className="col-12"></FormFeedback>
                    </InputGroup>
                    
                    
                    <Row>
                      <Col>
                        <Button 
                          disabled={this.state.username && this.state.password != '' ? false : true}
                          onClick={(e) => this.SendLogin()} color="primary" className="px-4 float-right">Login</Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js